import { type TranslationTree } from '@/i18n/types';

export const messages = {
  add: 'Adicionar imagem',
  replace: 'Trocar imagem',
  remove: 'Remover imagem',
  alt: 'Imagem da oferta',
  hint: 'Horizontal, 16:9, JPG, PNG ou WebP até 5 MB. Sem texto na imagem: o título e a ação vão por cima no app.',
  invalidImage: 'Use uma imagem JPG, PNG ou WebP',
  cropTitle: 'Ajustar imagem',
} satisfies TranslationTree;
